export default "__VITE_ASSET__c3bfQ8sz__"